const alternativeSummary = (
  <div className="alternative-pathways-summary">
    <div className="mb-4">
      <h3 className="text-lg font-semibold mb-2">Exploring Alternative Job Search Methods</h3>
      <ul className="list-disc pl-6">
        <li>
          Job searching isn't just about LeetCode and online applications—there are other ways!
        </li>
        <li>
          Networking, career fairs, conferences, and clubs can lead to direct recruiter connections.
        </li>
        <li>These methods can reduce competition and increase your chances of landing a job.</li>
      </ul>
    </div>

    <div className="mb-4">
      <h3 className="text-lg font-semibold mb-2">Networking Strategies</h3>
      <ul className="list-disc pl-6">
        <li>
          Reach out to alumni, attend networking events, and engage with professionals on LinkedIn.
        </li>
        <li>Consistent networking can open doors to referrals and job opportunities.</li>
        <li>Join online communities, hackathons, and industry meetups to expand your network.</li>
      </ul>
    </div>

    <div className="mb-4">
      <h3 className="text-lg font-semibold mb-2">Maximizing Career Fairs</h3>
      <ul className="list-disc pl-6">
        <li>Prepare a strong elevator pitch to make a memorable impression.</li>
        <li>Research companies beforehand and ask insightful questions.</li>
        <li>Follow up with recruiters after the event to reinforce connections.</li>
      </ul>
    </div>

    <div className="mb-4">
      <h3 className="text-lg font-semibold mb-2">Leveraging Conferences</h3>
      <ul className="list-disc pl-6">
        <li>Industry conferences offer networking sessions and on-site interview opportunities.</li>
        <li>
          Look for tech conferences like Grace Hopper, NSBE, or regional events in your field.
        </li>
        <li>Many conferences offer student discounts—take advantage of them!</li>
      </ul>
    </div>

    <div className="mb-4">
      <h3 className="text-lg font-semibold mb-2">Getting Involved in Clubs & Organizations</h3>
      <ul className="list-disc pl-6">
        <li>
          Joining a tech club or hackathon team helps you meet like-minded peers and industry
          professionals.
        </li>
        <li>
          Many clubs have direct relationships with recruiters, providing exclusive job
          opportunities.
        </li>
        <li>Working on team projects enhances your resume and demonstrates hands-on experience.</li>
      </ul>
    </div>

    <div className="mb-4">
      <h3 className="text-lg font-semibold mb-2">Actionable Next Steps</h3>
      <ul className="list-disc pl-6">
        <li>
          Choose one of these methods to focus on and start engaging with professionals this week.
        </li>
        <li>Reach out to at least one new person and build connections proactively.</li>
        <li>Remember: Job hunting isn't just about applying—it's about making real connections!</li>
      </ul>
    </div>
  </div>
);

export default alternativeSummary;
